import { Link, useLocation } from "react-router-dom";
import { Home, Star, Gift, FileText, MessageSquare } from "lucide-react";

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  
  const links = [
    { path: "/", icon: Home, label: "Home" },
    { path: "/casinos", icon: Star, label: "Casinos" },
    { path: "/bonuses", icon: Gift, label: "Bonuses" },
    { path: "/blog", icon: FileText, label: "Blog" },
    { path: "/complaint", icon: MessageSquare, label: "Support" },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50" style={{background:"linear-gradient(135deg,#1a0533,#2d0a5e)",borderTop:"1px solid rgba(168,85,247,0.3)",boxShadow:"0 -4px 20px rgba(139,44,226,0.2)"}}>
      <div style={{display:"flex",justifyContent:"space-around",padding:"8px 0 12px"}}>
        {links.map((link) => {
          const active = pathname === link.path;
          return (
            <Link key={link.path} to={link.path} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"3px",textDecoration:"none",padding:"4px 12px",borderRadius:"12px",background:active?"rgba(168,85,247,0.2)":"transparent",transition:"all 0.2s"}}>
              <link.icon style={{width:"20px",height:"20px",color:active?"#a855f7":"rgba(255,255,255,0.5)"}} />
              <span style={{fontSize:"0.6rem",fontWeight:active?"bold":"normal",color:active?"#a855f7":"rgba(255,255,255,0.5)"}}>{link.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
